import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import Icon3 from "../../assest/images//Icon3.png";
import Icon4 from "../../assest/images//Icon4.png";
import Icon9 from "../../assest/images//Icon9.png";
import x from "../../assest/images/x.png";
import Image from "../common/image";
import { ToastContainer, toast } from "react-toastify";
import CustomDropdown from "../common/CustomDropdown";
import config from "../../envconfig";
import { UserContext } from "../common/UserContext";

function LGCMList() {
  const [userData, setUserdata] = useState([]);
  const [message, setMessage] = useState("");
  const [vehicleNumbers, setVehicleNumbers] = useState([]);
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
  } = useContext(UserContext);
  const [firstFilter] = useState("LGCM_Name");
  const [firstFilterSearch, setFirstFilterSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [statusFilter, setStatusFilter] = useState("");
  const [firstFilterOptions] = useState([
    { value: "LGCM_Name", label: "Logistic Party Name", disabled: false },
  ]);

  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [suspendId, setSuspendId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [remark, setRemark] = useState("");
  const [error, setError] = useState("");

  // Helper function to remove all formatting characters from phone number
  const cleanPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "";
    return phoneNumber.replace(/[\s+\-()]/g, "");
  };

  // Helper function to format phone number for display with country code
  const formatPhoneNumberDisplay = (phoneNumber) => {
    if (!phoneNumber) return "";

    // Clean the number first
    const cleanedNumber = cleanPhoneNumber(phoneNumber);

    // Check which country code the number starts with
    if (cleanedNumber.startsWith("91") && cleanedNumber.length === 12) {
      // India: +91 98765 43210
      return `+91 ${cleanedNumber.slice(2, 7)} ${cleanedNumber.slice(7)}`;
    } else if (cleanedNumber.startsWith("93") && cleanedNumber.length === 11) {
      // Afghanistan: +93 701 234 567
      return `+93 ${cleanedNumber.slice(2, 5)} ${cleanedNumber.slice(5, 8)} ${cleanedNumber.slice(8)}`;
    } else if (cleanedNumber.startsWith("213") && cleanedNumber.length === 12) {
      // Algeria: +213 551 23 45 67
      return `+213 ${cleanedNumber.slice(3, 6)} ${cleanedNumber.slice(6, 8)} ${cleanedNumber.slice(8, 10)} ${cleanedNumber.slice(10)}`;
    } else if (cleanedNumber.startsWith("61") && cleanedNumber.length === 11) {
      // Australia: +61 412 345 678
      return `+61 ${cleanedNumber.slice(2, 5)} ${cleanedNumber.slice(5, 8)} ${cleanedNumber.slice(8)}`;
    } else if (cleanedNumber.startsWith("43") && cleanedNumber.length === 12) {
      // Austria: +43 664 123 4567
      return `+43 ${cleanedNumber.slice(2, 5)} ${cleanedNumber.slice(5, 8)} ${cleanedNumber.slice(8)}`;
    } else if (cleanedNumber.startsWith("32") && cleanedNumber.length === 11) {
      // Belgium: +32 470 12 34 56
      return `+32 ${cleanedNumber.slice(2, 5)} ${cleanedNumber.slice(5, 7)} ${cleanedNumber.slice(7, 9)} ${cleanedNumber.slice(9)}`;
    } else if (cleanedNumber.startsWith("1") && cleanedNumber.length === 11) {
      // USA: +1 201 555 0123
      return `+1 ${cleanedNumber.slice(1, 4)} ${cleanedNumber.slice(4, 7)} ${cleanedNumber.slice(7)}`;
    }

    // If no specific format matches, return as is with + prefix
    return cleanedNumber.startsWith("+") ? cleanedNumber : `+${cleanedNumber}`;
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [firstFilterSearch, statusFilter]);

  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);
    sessionStorage.setItem("selectedScpId", selectedScpId);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
  ]);

  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Company Group Master:",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  const logAudit = async (
    module,
    message,
    oldValue = "",
    newValue = "",
    isError = false,
    transactionDetails = [],
  ) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 7,
      AUTR_SCPID: selectedScpId || null,
      AUTR_CompanyGrpId: UM_CompanyGrpID || null,
      AUTR_CompanyID: UM_CompanyID || null,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0,
      transactionDetails,
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  useEffect(() => {
    const getUserdata = async () => {
      try {
        const reqData = await fetch(
          `${config.API_URL}/logistic_company_master/list/${selectedScpId}`,
          {
            method: "GET",
          },
        );
        if (reqData.ok) {
          const resData = await reqData.json();
          setUserdata(resData);
        } else {
          console.error("Error fetching the company list");
        }
      } catch (error) {
        console.log("Failed to fetch data:", error);
        setMessage("Please check Data");
      }
    };
    getUserdata();
  }, [selectedScpId]);

  const handlePoolImageClick = (LGCVM_LogisticCompanyID) => {
    try {
      const fetchVehicleNumbers = async () => {
        const response = await fetch(
          `${config.API_URL}/logistic_company_master/fetchvehicle_numbers/${LGCVM_LogisticCompanyID}`,
        );
        if (!response.ok) {
          throw new Error("Failed to fetch vehicle numbers");
        }
        const vehicleNumbers = await response.json();
        setVehicleNumbers(vehicleNumbers);
        setShowPopup(true);
      };

      fetchVehicleNumbers();
    } catch (error) {
      console.error("Error fetching vehicle numbers:", error);
    }
  };

  const handleSuspendWithConfirmation = (LGCM_ID) => {
    setRemark("");
    setSuspendId(LGCM_ID);
    setShowConfirmationPopup(true);
    setError("");
  };

  const handleStatusFilterChange = (event) => {
    const value = event.target.value;
    logAction("handleStatusFilterChange(): Status is changed in the dropdown");
    setStatusFilter(value);
    logAction(
      "handleStatusFilterChange(): Data filtered according to the selected status",
    );
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      case 3:
        return "Suspend";
      default:
        return "";
    }
  };

  const filteredListData = userData.filter((item) => {
    const firstFilterValue = item[firstFilter];
    const statusValue = getStatusLabel(item.LGCM_Status);

    const matchesFirstFilter =
      !firstFilter ||
      !firstFilterSearch ||
      String(firstFilterValue)
        .toLowerCase()
        .includes(firstFilterSearch.toLowerCase());

    const matchesStatusFilter = !statusFilter || statusValue === statusFilter;

    return matchesFirstFilter && matchesStatusFilter;
  });

  const confirmSuspend = async (remark) => {
    try {
      // 1️⃣ Get all vehicle numbers (and vehicle IDs)
      const vehicleListResponse = await fetch(
        `${config.API_URL}/logistic_company_master/fetchvehicle_numbers/${suspendId}`,
      );

      if (!vehicleListResponse.ok) {
        toast.error("Failed to fetch vehicles for this logistic party.");
        return;
      }

      const vehicleList = await vehicleListResponse.json();

      // Extract all LGCVM_IDs
      const vehicleIds = vehicleList.map((v) => v.LGCVM_ID);

      // 2️⃣ Call NEW API to check shipments (multiple vehicles)
      const shipmentCheckResponse = await fetch(
        `${config.API_URL}/logistic_company_master/logistic_company_vehicle_numbers`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            LGCM_ID: suspendId,
            vehicleIds: vehicleIds,
          }),
        },
      );

      const shipmentData = await shipmentCheckResponse.json();

      // 3️⃣ If shipments exist → DO NOT allow suspension
      if (!shipmentData.canSuspend) {
        //toast.error(`You cannot suspend Logistic Party Name : ${userData.find(company => company.LGCM_ID === suspendId)?.LGCM_Name} because ${vehicleCount} active vehicles linked to this logistic company .`);

        toast.error(
          `You cannot suspend the Logistic Party : ${userData.find((c) => c.LGCM_ID === suspendId)?.LGCM_Name
          } because ${shipmentData.count} active vehicles linked to this logistic company.`,
        );
        setShowConfirmationPopup(false);
        return;
      }

      // 4️⃣ If no shipments → PROCEED WITH SUSPEND API
      const response = await fetch(
        `${config.API_URL}/logistic_company_master/Suspend/${suspendId}`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            LGCM_Status: 3,
            remark: remark,
          }),
        },
      );

      if (response.ok) {
        const updatedUserData = userData.map((item) =>
          item.LGCM_ID === suspendId ? { ...item, LGCM_Status: 3 } : item,
        );

        setUserdata(updatedUserData);

        toast.success(
          `Logistic Party : ${userData.find((c) => c.LGCM_ID === suspendId)?.LGCM_Name
          } suspended successfully.`,
        );

        logAudit(
          "Logistic Party Master",
          `Logistic Party Suspended Successfully.`,
          "",
          "Suspend",
        );
      } else {
        toast.error("Error updating status.");
      }
    } catch (error) {
      console.error("Suspend error:", error);
      toast.error("Error processing request.");
    }

    setShowConfirmationPopup(false);
  };

  const handleConfirm = () => {
    if (!remark.trim()) {
      setError("*");
    } else {
      setError("");
      confirmSuspend(remark);
    }
  };

  const handleRemarkChange = (e) => {
    const value = e.target.value;
    setRemark(value);
    if (error && value.trim() !== "") {
      setError(false); // Clear the error once the user starts typing
    }
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredListData.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };
  return (
    <React.Fragment>
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      <div className="main_container">
        <div className="row">
          <div className="col-md-12">
            <h5 className="formHeading">Logistic Party Master</h5>
            <p>{message}</p>
            <div className="filter-container">
              <div className="select-container_list">
                <select
                  defaultValue="LGCM_Name"
                  name="firstFilter"
                  disabled
                  className="select-box"
                  onMenuOpen={() => handleSelectOpen("firstFilter")}
                  onMenuClose={handleSelectClose}
                >
                  {firstFilterOptions.map((option) => (
                    <option
                      key={option.value}
                      value={option.value}
                      disabled={option.disabled}
                    >
                      {option.label}
                    </option>
                  ))}
                </select>
                {/* <div className='icon-container'>
                                    {isSelectOpen === 'UM_DefaultSCPId' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                                </div> */}
              </div>

              <input
                type="text"
                className="search-input"
                value={firstFilterSearch}
                onChange={(e) => setFirstFilterSearch(e.target.value)}
                placeholder={`Search`}
              />

              <div className="select-container_list">
                <CustomDropdown
                  options={[
                    { value: "Active", label: "Active" },
                    { value: "Inactive", label: "Inactive" },
                    { value: "Suspend", label: "Suspend" },
                  ]}
                  value={statusFilter}
                  onChange={handleStatusFilterChange}
                  name="statusFilter"
                  placeholder="--Select Status--"
                  idKey="value"
                  displayKey="label"
                />
              </div>
            </div>
            <div className="ptable-wrapper">
              <table className="ptableClass">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Logistic Party Name</th>
                    <th>Vehicle Details</th>
                    <th>Status</th>
                    <th style={{ textAlign: "center" }}>Action</th>
                  </tr>
                </thead>
                {filteredListData.length === 0 ? (
                  <tbody>
                    <tr>
                      <td colSpan="9">No Records Found</td>{" "}
                      {/* Set colSpan to match the number of columns */}
                    </tr>
                  </tbody>
                ) : (
                  <tbody>
                    {currentItems.map((user, index) => (
                      <tr key={index}>
                        <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                        <td>{user.LGCM_Name}</td>

                        <td>
                          {user.LGCM_Status === 3 ? (
                            "-"
                          ) : (
                            <>
                              {user.LGCM_VehicleNumber || ""}
                              <img
                                src={Icon9}
                                title="Details"
                                alt="Pool"
                                style={{ cursor: "pointer", marginLeft: "5px" }}
                                onClick={() =>
                                  handlePoolImageClick(user.LGCM_ID)
                                }
                              />
                            </>
                          )}
                        </td>

                        <td>
                          {user.LGCM_Status === 1 && "Active"}
                          {user.LGCM_Status === 2 && "Inactive"}
                          {user.LGCM_Status === 3 && "Suspend"}
                        </td>

                        <td style={{ textAlign: "center" }}>
                          {user.LGCM_Status === 3 ? (
                            "-"
                          ) : (
                            <>
                              {user.LGCM_Status !== 3 && (
                                <Link to={`/lgcmedit/${user.LGCM_ID}`}>
                                  <img
                                    src={Icon3}
                                    alt="Edit"
                                    title="Edit"
                                    className="editicon"
                                    style={{ marginRight: 6 }}
                                  />
                                </Link>
                              )}

                              {user.LGCM_Status !== 3 && (
                                <img
                                  src={Icon4}
                                  onClick={() =>
                                    handleSuspendWithConfirmation(user.LGCM_ID)
                                  }
                                  className="suspendicon"
                                  alt="suspend"
                                  title="Suspend"
                                  style={{ marginRight: 0 }}
                                />
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>
            {showPopup && (
              <div className="popup_overlay">
                <div className="popup">
                  <div className="popup-inner">
                    <div>
                      <Link onClick={() => setShowPopup(false)}>
                        <Image src={x} alt="x" className="x" />
                      </Link>
                    </div>
                    <h1>Vehicle Details</h1>
                    <table className="tableClass">
                      <thead>
                        <tr>
                          <th>Sr. No.</th>
                          <th>Vehicle Name</th>
                          <th>Vehicle Number</th>
                          <th>Vehicle Volume</th>
                          <th>Driver Name</th>
                          <th>Driver Phone Number</th>
                        </tr>
                      </thead>

                      <tbody>
                        {vehicleNumbers.map((vehicle, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{vehicle.LGCVM_VehicleName || "-"}</td>
                            <td>{vehicle.LGCVM_VehicleNumber}</td>
                            <td>{vehicle.LGCVM_Dimension || "-"}</td>
                            <td>{vehicle.LGCVM_DriverName || "-"}</td>
                            <td>
                              {vehicle.LGCVM_DriverNumber
                                ? formatPhoneNumberDisplay(
                                  vehicle.LGCVM_DriverNumber,
                                )
                                : "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <ul className="pagination">
          <li
            className={
              currentPage === 1 || filteredListData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button className="page-linkd" onClick={() => paginate(1)}>
              First
            </button>
          </li>

          <li
            className={
              currentPage === 1 || filteredListData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() => paginate(currentPage - 1)}
            >
              Previous
            </button>
          </li>

          {Array.from(
            { length: Math.ceil(filteredListData.length / itemsPerPage) },
            (_, index) => (
              <li
                key={index}
                className={
                  currentPage === index + 1 ? "page-item active" : "page-item"
                }
              >
                <button
                  className="page-linkd"
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ),
          )}

          <li
            className={
              currentPage ===
                Math.ceil(filteredListData.length / itemsPerPage) ||
                filteredListData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() => paginate(currentPage + 1)}
            >
              Next
            </button>
          </li>

          <li
            className={
              currentPage ===
                Math.ceil(filteredListData.length / itemsPerPage) ||
                filteredListData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() =>
                paginate(Math.ceil(filteredListData.length / itemsPerPage))
              }
            >
              Last
            </button>
          </li>
        </ul>
      </div>

      {showConfirmationPopup && (
        <div className="popup_overlay">
          <div className="resetpopup">
            <h1>:: User Confirmation ::</h1>
            <h4>{`Are you sure you want to suspend this Logistic Party : ${userData.find((company) => company.LGCM_ID === suspendId)?.LGCM_Name} ?`}</h4>
            <div className="remark_container">
              <span className="me-3 remark_label">
                Remark:
                {error && <span style={{ color: "red" }}>{error}</span>}
              </span>
              <textarea
                type="text"
                className="remark_text"
                value={remark}
                onChange={(e) => handleRemarkChange(e, setRemark, setError)}
                placeholder="Enter suspend remark"
                style={{
                  border: "1px solid #ced4da",
                  padding: "10px",
                  fontSize: "16px",
                  resize: "none",
                  overflow: "auto",
                  transition: "height 0.3s",
                  borderRadius: "5px",
                  outline: "none",
                }}
              />
            </div>
            <div className="popup_btn_container">
              <button className="yes_btn" onClick={() => handleConfirm(remark)}>
                Yes
              </button>
              <button
                className="no_btn"
                onClick={() => setShowConfirmationPopup(false)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      <Link to={`/dashboard/lgcm`} className="back_btn" type="button">
        BACK
      </Link>
    </React.Fragment>
  );
}

export default LGCMList;
